import {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    MwSmallIcon,
} from "../../components/v2/icons";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import Card from "../../components/v2/cards/card";
import ProductHeroSection from "../../components/v2/common/product-hero";
import SolutionFeatureSection from "../../components/v2/common/solution-feature";
import '../../styles/scss/_faq-section.module.scss';

export default function GCPSolutions() {
    const { t } = useTranslation("common");
    const i18nData = t('solutions.gcp', { returnObjects: true }) as any
    const [imageOpen, setImageOpen] = useState(false);
    const [imageURL, setImageURL] = useState("");

    const technologyCards = Array.isArray(i18nData?.whyUs?.cards) ? i18nData.whyUs.cards : []

    const faqs = Array.isArray(i18nData?.faq?.questions) ? i18nData.faq.questions : []

    const resource = Array.isArray(i18nData?.resources) ? i18nData.resources : []

    function imageDialog(url: string) {
        setImageOpen(true)
        setImageURL(url)
    }

    const sectionsData = Array.isArray(i18nData?.section?.sections) ? i18nData.section.sections : []

    return (
        <>
            <ProductHeroSection title={<h1>{i18nData?.hero?.titlePrefix} <br/><span>{i18nData?.hero?.titleSuffix}</span></h1>}
                                description={i18nData?.hero?.description}
                                img={i18nData?.hero?.image} imgMobile={i18nData?.hero?.imageMobile} imgAlt={i18nData?.hero?.imageAlt} hasActions={true} className={"solutions-page"} preloadImg />


            <section className={'mw-card'}>
                <div className={'container'}>
                <div className={'d-flex card-items'}>
                        <div className={'card-item'}>
                            <div className={'section-tag testimonial pd-right'}><MwSmallIcon/>{i18nData?.whyUs?.tag}</div>
                            <h2>{i18nData?.whyUs?.title}</h2>
                        </div>
                        {
                            technologyCards.map((item, index) => {
                                return <Card heading={item.heading}
                                             description={item.description}
                                             isHeading={item.isHeading}/>
                            })
                        }
                    </div>
                </div>
            </section>

            <section className={"user-monitor"}>
                <div className={"container"}>
                    <h2>{i18nData?.section?.title}</h2>
                    <p>{i18nData?.section?.description}</p>

                    {sectionsData.map((section, index) => (
                        <SolutionFeatureSection
                            image={section.image}
                            imageAlt={section.imageAlt}
                            title={section.title}
                            list={section.list}
                            category={section.category}
                        />
                    ))}

                </div>
            </section>

            <ProductResources resources={resource}/>

            <section className={"faq-section"}>
                <div className={"container"}>
                    <h2>{i18nData?.faq?.title}</h2>
                    <p>{i18nData?.faq?.subtitle}</p>
                    <div className={"faq-item"}>
                        <Accordion faqs={faqs} showGroups={true}/>
                    </div>
                </div>
            </section>

        </>
    )
}